// src/components/Sidebar/CustomSideBar.tsx (replace your current file)
import { useEffect, useState } from "react";
import "./CustomSideBar.css";
import { useNavigate } from "react-router-dom";
import WebService from "../../utility/WebService";

import UpIcon from "../../assets/up-arrow.svg";
import DownIcon from "../../assets/down-arrow.svg";

// icon map by menu.key (fallback to a default)
const ICON_MAP: Record<string, any> = {
  "About": require("../../assets/about.png"),
  "Membership": require("../../assets/membership.png"),
  "Events": require("../../assets/events.png"),
  "Resources": require("../../assets/resource.png"),
  "Initiatives": require("../../assets/initiative.png"),
  "Academy": require("../../assets/academy.png"),
  "Media": require("../../assets/updates.png"),
  "Users": require("../../assets/members.png"),
  "Settings": require("../../assets/setting_icon.png"),
  "Transactions": require("../../assets/transaction.png"),
  "Councils": require("../../assets/council.png"),
  "Organization": require("../../assets/icon-organization.png"),
  "Home": require("../../assets/icon-home.png"),
  "Coupon Code": require("../../assets/coupon_code.png")
};


const CustomSideBar = () => {
  const navigate = useNavigate();

  const [menus, setMenus] = useState<any[]>([]);
  const [permissions, setPermissions] = useState<any[]>([]);
  // use a Set of open menu ids so expand/collapse is by id
  const [openSet, setOpenSet] = useState<Set<string>>(new Set());
useEffect(() => {
  loadSidebarSequential();
  fetchPermissions();
}, []);

const loadSidebarSequential = async () => {
  try {
    // 1️⃣ MENUS LAO
    const menuRes: any = await WebService.getAPI({ action: "role/left-menues" });
    const menuList = menuRes?.data || [];
    setMenus(menuList);

    console.log("MENU LOADED:", menuList);


    const meRes: any = await WebService.getAPI({ action: "users/me" });
    console.log(",eRes", meRes)
    const permList = meRes?.data?.role?.permissions || [];
    setPermissions(permList);

    console.log("PERMISSIONS LOADED:", permList);

  } catch (err) {
    console.log("Sidebar load error", err);
  }
};

const fetchPermissions = async () => {
//  alert("f")
  try {
    const meRes: any = await WebService.getAPI({ action: "users/me" });
    console.log(",eRes", meRes)
    const permList = meRes?.data?.role?.permissions || [];
    setPermissions(permList);

    console.log("PERMISSIONS LOADED:", permList);

  } catch (err) {
    console.log("Sidebar load error", err);
  }
};
  // permission check (always compare strings)
  const canView = (menuId: string) => {
    if (!permissions || !permissions.length) {
      // fallback: if no permissions present, show everything (for testing)
      return true;
    }
    return !!permissions.find(
      (p: any) => String(p.menuId) === String(menuId) && p.canView
    );
  };

  const toggleOpen = (id: string) => {
    setOpenSet((prev) => {
      const n = new Set(prev);
      if (n.has(id)) n.delete(id);
      else n.add(id);
      return n;
    });
  };

  const renderSub = (sub: any) => {
    if (!canView(sub._id)) return null;
    return (
      <li
        key={sub._id}
        className="sidebar-suboption mt-2"
        onClick={() => sub.path && navigate(sub.path)}
      >
        {sub.title}
      </li>
    );
  };

  const renderMenu = (menu: any) => {
    if (!canView(menu._id)) return null;

    const hasChildren =
      Array.isArray(menu.children) && menu.children.length > 0;
    const isOpen = openSet.has(menu._id);

   const icon = ICON_MAP[menu.title] || ICON_MAP["About"];

    return (
      <li key={menu._id}>
        <div
          className="sidebar-menu-item mt-1"
          onClick={() => {
            if (!hasChildren && menu.path) navigate(menu.path);
            else toggleOpen(menu._id);
          }}
          style={{
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
           whiteSpace: "nowrap",
          }}
        >
          <div>
            <img
              src={icon}
              alt={menu.title}
              style={{ width: 22, marginRight: 12 }}
            />
            <span className="menu-title">{menu.title}</span>
          </div>

          {hasChildren && (
            <span>
              {isOpen ? (
                <img src={UpIcon} className="opacity-75" alt="Collapse" height={7} />
              ) : (
                <img src={DownIcon} className="opacity-75" alt="Expand" height={7} />
              )}
            </span>
          )}
        </div>

        {hasChildren && isOpen && (
          <ul className="sidebar-submenu">
            {menu.children.map((sub: any) => renderSub(sub))}
          </ul>
        )}
      </li>
    );
  };

  return (
    <div className="custom-sidebar">
      <ul className="p-0" style={{ marginBottom: 100 }}>
        {menus.map((menu) => renderMenu(menu))}
      </ul>
    </div>
  );
};

export default CustomSideBar;
